import firebase from './firebase';

// Implement perssistence if issue with DB repeats : https://firebase.google.com/docs/firestore/manage-data/enable-offline

const db = firebase.firestore();

const settings = {
  experimentalForceLongPolling: true // to allow for proxy based on https://github.com/firebase/firebase-js-sdk/issues/2923#issuecomment-630382211
};
db.settings(settings);

export default db;



// WEBPACK FOOTER //
// ./src/db.js